export enum EntityTypeEnum {
  CLIENT = "client",
  PROVIDER = "provider",
}
